import React from 'react'
import PropTypes from 'prop-types'
import { createPortal } from 'react-dom'
import usePortalTarget from 'hooks/usePortalTarget'

interface PageTitleCenterActionsProps {
  children: any
}

export const PAGE_TITLE_CENTER_ACTIONS_ID = 'PAGE_TITLE_CENTER_ACTIONS_ID'

export const PageTitleCenterActions: React.FunctionComponent<PageTitleCenterActionsProps> = ({
  children,
}) => {
  const target = usePortalTarget(PAGE_TITLE_CENTER_ACTIONS_ID, 'span')

  return createPortal(children, target)
}

PageTitleCenterActions.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.element,
    PropTypes.string,
    PropTypes.node,
  ]),
}
